<template>
  <div>
    <loading v-if="!data"></loading>
    <div class="" v-else>
      <div class="kris-redaktor-format">
        <div class="h3"></div>
      </div>
      <div class="kris-documents-box">
        <ul class="kris-doclist">
          <file v-for="(item,key) in data" v-bind:key="key" ext="pdf" :title="'Положение о создании волонтерского отряда ' + item.teams  " :link="item.url" />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from './components/Loading'
import File from './components/File'
import { GET_DOCS } from './store/actions.types'
import { SET_EO_ID } from './store/mutations.types'
import { mapState } from 'vuex'
export default {
  name: 'App',
  components: {
    file: File,
    loading: Loading
  },
  computed: {
    ...mapState({
      data: 'docs'
    })
  },
  mounted () {
    this.$store.commit(SET_EO_ID, document.body.getAttribute('data-eo-id'))
    this.$store.dispatch(GET_DOCS)
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
